import * as signalR from '@microsoft/signalr';

export const signalRConfig = {
    hubUrl: `${process.env.REACT_APP_BASE_URL}/hubs/notifications`,
};

export const connection = new signalR.HubConnectionBuilder()
    .withUrl(signalRConfig.hubUrl)
    .withAutomaticReconnect()
    .build();